import React from "react";
import Validation from "../validation/validation";
import "./inputReport.css";

export default class InputReport extends React.Component {
  state = { text: "" };


  onChangeText = (text) => {
    let aux = Validation(this.props.validationType,text.target.value);
    this.setState({ text: aux });
    this.props.parentCallback({
      value: aux,
      name: text.target.name,
    })
  };

  render() {
    return (
      <div className="insideContainer">
          <label className="reportLabel">
            <strong>{this.props.title}:</strong>
          </label>
          <input
            autoFocus={this.props.focus}
            name={this.props.name}
            value={this.state.text}
            type="text"
            onChange={this.onChangeText}
            className={"Inside "}
            autoComplete="off"
            minlength={this.props.min}
            maxlength={this.props.max}
            pattern={this.props.pattern}
          />
      </div>
      
    );
  }
}
